// "On the desk: Triage · waiting on Jess · asks sent: Laura ✓ sent Oct 6 …"
// — the second line on an admin Quality Routing row (proposal 12, kanban
// 0aac3112). The desk link opens the item on the quality door (same-tab SPA
// link; staging holds the session in memory).

import React from 'react';
import { Link } from 'react-router-dom';

import type { DeskLocation, TrackedThread } from '../services/qualityRouting';
import { trackEventNow } from '../services/portalTracking';
import { askPill, asksByPerson, deskHref, deskLabel, noAnswers } from './qualityRoutingDeskView';
import styles from './QualityRoutingDeskLine.module.css';

interface Props {
  thread: TrackedThread & { desk_location: DeskLocation };
}

export function QualityRoutingDeskLine({ thread }: Props): React.ReactElement {
  const asks = thread.asks ?? [];
  const href = deskHref(thread);
  return (
    <div className={styles.line} data-testid="desk-line">
      On the desk:{' '}
      <Link
        to={href}
        className={styles.deskLink}
        onClick={(e) => {
          // The row toggles its detail on click; the link must not.
          e.stopPropagation();
          trackEventNow('click', 'routing_row_open_on_desk', {
            thread_id: thread.id,
            thread_no: thread.thread_no,
            desk_location: thread.desk_location,
            case_no: thread.case_no ?? null,
            to: href,
          });
        }}
      >
        {deskLabel(thread)}
      </Link>
      {' · '}asks sent:{' '}
      {asks.length === 0
        ? 'none'
        : asksByPerson(asks).map((person, i) => (
            <React.Fragment key={person.name}>
              {i > 0 && ', '}
              {person.name}
              {person.asks.map((a, j) => {
                const pill = askPill(a);
                return (
                  <React.Fragment key={`${a.sent_at ?? ''}-${j}`}>
                    {' '}
                    <span className={styles.pill} data-tone={pill.tone}>
                      {pill.text}
                    </span>
                  </React.Fragment>
                );
              })}
            </React.Fragment>
          ))}
      {noAnswers(asks) && ' · no answers'}
    </div>
  );
}

export default QualityRoutingDeskLine;
